export default __webpack_public_path__ + "static/media/cladding27.ca96c2dc.jpg";